import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseCountry() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
    };

    setter(errorState);

    if (errorState.faName || errorState.enName) {
      enqueueSnackbar("لطفا اطلاعات کشور را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getCountryList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Countries?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllCountryList = (callback) => {
    MyAxios.get(`Admin_Countries?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getCountryByID = (id, callback) => {
    MyAxios.get(`Admin_Countries/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateCountry = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("file", file);
    }

    MyAxios.post(`Admin_Countries`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کشور با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addCountry = (state, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (file) {
      data.append("file", file);
    }

    MyAxios.post(`Admin_Countries`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کشور با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteCountry = (id, callback) => {
    const data = new FormData();
    data.append("CountryID", id);
    MyAxios.delete(`Admin_Countries`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کشور با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getCountryList,
    getAllCountryList,
    getCountryByID,
    validate,
    updateCountry,
    addCountry,
    deleteCountry,
  };
}
